export function isEmptyObject(value) {
  if (value == null) return true
  if (typeof value !== 'object') return false
  return Object.keys(value).length === 0
}
